export default __webpack_public_path__ + "static/media/learning.03d19e60.jpg";